"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateQualificationExperienceDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class UpdateQualificationExperienceDto {
}
exports.UpdateQualificationExperienceDto = UpdateQualificationExperienceDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "ID of the qualification", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQualificationExperienceDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact ID associated with the qualification",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateQualificationExperienceDto.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Name of the qualification", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, {
        message: "Name of qualification must not exceed 100 characters",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateQualificationExperienceDto.prototype, "nameOfQualification", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Year of the qualification", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1900, { message: "Year of qualification must be 1900 or later" }),
    (0, class_validator_1.Max)(new Date().getFullYear(), {
        message: "Year of qualification cannot be in the future",
    }),
    tslib_1.__metadata("design:type", Number)
], UpdateQualificationExperienceDto.prototype, "yearOfQualification", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Details of the qualification", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Details must be a string" }),
    (0, class_validator_1.MaxLength)(500, { message: "Details must not exceed 500 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateQualificationExperienceDto.prototype, "details", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "University Name of the qualification",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "University Name must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "University Name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateQualificationExperienceDto.prototype, "universityName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQualificationExperienceDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateQualificationExperienceDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateQualificationExperienceDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], UpdateQualificationExperienceDto.prototype, "updatedAt", void 0);
